import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import * as dat from 'lil-gui';
import Stats from 'stats.js';

export default class Project {

    static instance;
 
    constructor(options = {}){

        if(Project.instance){
            return Project.instance;
        }

        Project.instance = this;

        //TODO options는 나중에

        //
        this.windowSize = null;
        this._setWindowSize();

        //
        this.canvas = document.querySelector('canvas.webgl');
        this.scene = new THREE.Scene();
        this.camera = this._initCamera();
        this.renderer = this._initRenderer();
        this.gui = new dat.GUI();
        //optional
        this.controls = null; 
        this.stats = null;

        //event callbacks. 
        this.onResize = null;   //TODO Array..?

        //
        window.THREE = this;
        ['resize','orientationchange'].forEach((evt)=>{
            window.addEventListener(evt,this._resizeEvent);
        });
    }

    _resizeEvent =  () => {
        this._setWindowSize();
        const {width, height, pixelRatio} = this.windowSize;
    
        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();
    
        this.renderer.setSize(width, height);
        this.renderer.setPixelRatio(pixelRatio);

        this.onResize && this.onResize(width, height, pixelRatio);
    }


    _setWindowSize = () => {

        this.windowSize = {
            width:window.innerWidth,
            height:window.innerHeight,
            pixelRatio:Math.min(window.devicePixelRatio, 2)
        }
    }


    _initCamera = () => {

        const aspect = this.windowSize.width / this.windowSize.height;
        const camera = new THREE.PerspectiveCamera(75, aspect, 0.1, 1000);

        return camera;
    }


    _initRenderer = () => {

        const {width, height, pixelRatio} = this.windowSize;

        const renderer = new THREE.WebGLRenderer({canvas: this.canvas, antialias:true});
        renderer.setSize(width, height);
        renderer.setPixelRatio(pixelRatio);

        return renderer;
    }


    initControls = () => {
        this.controls = new OrbitControls(this.camera, this.canvas);
        this.controls.enableDamping = true;
        //this.controls.enablePan = false;
        //this.controls.enableZoom = false;
        this.controls.maxDistance = 50;
        this.controls.maxZoom = 3;
    }


    initStatsJs = () => {

        if(!this.stats){
            this.stats = [];
        }
    
        for(let i=0; i<3; ++i){
    
            let statsJs = new Stats();
    
            // 0: fps, 1: ms, 2: mb, 3+: custom
            statsJs.showPanel(i);
        
            document.body.appendChild(statsJs.dom);
            statsJs.dom.style.position='relative';
            statsJs.dom.style.display='inline-block';
    
            this.stats.push(statsJs);
        }
    }


    update = () => {

        this.controls?.update();
        this.camera.updateProjectionMatrix();
        this.camera.updateMatrix();
        this.stats?.forEach(i => i.update());
    }
}